<div class="goreact-modal">
  <div class="modal-dialog">
    <div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
      <div class="goreact-modal-header">
        <h4 class="modal-title" translate="modal-video-share-dialog_title" [id]="dialogTitleId"></h4>
        <button
          type="button"
          class="close-btn"
          (click)="cancel()"
          [attr.aria-label]="'common_close' | translate"
          >
          <i class="ficon-app-x"></i>
        </button>
      </div>
      <div class="goreact-modal-body" #content [formGroup]="form">
        @if (showReviewersField()) {
          <div class="reviewers-field">
            <p>
              {{ "modal-video-share-dialog_message" | translate }}
              <button
                [goCdkPopover]="'modal-video-share_dialog-help' | translate"
                class="ficon-app-help-circle-outline icon-btn">
              </button>
            </p>
            <user-form-field
              [peers]="users"
              [allowVideoShare]="data.orgSettings.allow_video_share"
              formControlName="childForm">
            </user-form-field>
            <div class="right-align">
              @if (showInviteButtonAbove()) {
                <button
                  type="button"
                  data-cy="send-invite-button"
                  class="confirm-button primary-btn send-invite-btn"
                  (click)="sendInvite()"
                  [disabled]="isSaving$ | async"
							[focusOnFirstInvalidField]="{
								formGroup: form,
								formWrapper: content
							}"
                  >
                  {{
                  ((isSaving$ | async)
                  ? "invite-user-dialog_sending_invitations"
                  : "invite-user-dialog_send_invitations"
                  ) | translate
                  }}
                </button>
              }
            </div>
          </div>
        }

        @if (shouldShowGuestReviewers$ | async) {
          <div class="guest-reviewer-section">
            <div class="subheader guest-reviewers-subheader">
              <span translate="session-editor-panel_video-reviewers"></span>
              <div>
                @if (guestReviewersCount > 0) {
                  <button
                    type="button"
                    class="tertiary-btn guest-reviewer-cnt-btn"
                    (click)="manageVideoSharing()"
                    [matTooltip]="'session-list-item_manage-reviewers' | translate"
                    attr.aria-label="{{ guestReviewersCount > 1 ? 'modal-video-share_guest_reviewers_label-more' : 'modal-video-share_guest_reviewers_label' | translate: { numGuestReviewers: guestReviewersCount } }}">
                    <span class="ficon-app-users"></span>
                    <span class="guest-reviewer-count">{{ guestReviewersCount }}</span>
                  </button>
                }
              </div>
            </div>
            <video-reviewers
              [session]="session"
              [group]="group"
              [orgSettings]="data.orgSettings"
              (onDeleteReviewer)="onDeleteReviewer($event)">
            </video-reviewers>
          </div>
        }

        @if (showSeparator() && shareLink) {
          <div class="separator">
            <span translate="common_or-uppercase"></span>
          </div>
        }

        @if (allowsExternalShare()) {
          <div
            class="public-share-link"
            >
            @if (shareLink) {
              <div class="invite-link">
                <div class="public-share-label">
                  <span translate="modal-video-share_public-share-link"></span>
                  @if (data.orgSettings.allow_video_share === 'both' || data.orgSettings.allow_video_share === 'public') {
                    <button type="button"
                      class="btn-none expire-button"
                      (click)="expireAccess()"
                      [matTooltip]="'session-editor-panel_expire-link' | translate">
                      <i class="ficon-app-expire-link"></i>
                    </button>
                  }
                </div>
                <div class="invite-link-group">
                  <input
                    #shareLinkInput
                    class="form-control"
                    [value]="shareLink"
                    data-cy="share-link"
                    readonly="readonly"
                    [attr.aria-label]="'modal-video-share_public-share-link' | translate"
                    (focus)="onShareLinkFocus()"
                    (click)="onShareLinkFocus()"
                    (mouseup)="onShareLinkMouseUp($event)"
                    (copy)="onShareLinkCopy($event)"
                    />
                  <section [goCopyToClipboard]="shareLink" class="copy-clipboard">
                    <button
                      type="button"
                      class="btn-none"
                      [attr.aria-label]="'modal-video-share-dialog_copy' | translate">
                      <i class="ficon-app-copy"></i>
                    </button>
                  </section>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="goreact-modal-footer">
        @if (allowsExternalShare() && !shareLink) {
          <button
            type="button"
            [attr.aria-label]="'modal-video-share_create-public-share-link' | translate"
            data-cy="create-share-link"
            (click)="createPublicShareLink()"
            [disabled]="creatingLink$ | async"
            class="link-btn create-link create-share-tertiary-btn">
            <span translate="modal-video-share_create-public-share-link"></span>
            @if (creatingLink$ | async) {
              <span><i class="ficon-spinner ficon-spin"></i></span>
            }
          </button>
        }
        <button
          type="button"
          class="cancel-btn"
          [ngClass]="{'tertiary-btn': isPrivateShare() || isExternalVideoShareDisabled(), 'secondary-btn': !isPrivateShare()}"
          data-cy="close-sharing-modal"
          (click)="cancel()"
          >
          {{ (isPrivateShare() || isExternalVideoShareDisabled() ? 'common_cancel' : 'common_close') | translate }}
        </button>
        @if (isPrivateShare() || isExternalVideoShareDisabled()) {
          <button
            type="button"
            class="confirm-button primary-btn send-invite-btn"
            (click)="sendInvite()"
            [disabled]="isSaving$ | async"
					[focusOnFirstInvalidField]="{
						formGroup: form,
						formWrapper: content
					}"
            >
            {{
            ((isSaving$ | async)
            ? "invite-user-dialog_sending_invitations"
            : "invite-user-dialog_send_invitations"
            ) | translate
            }}
          </button>
        }
      </div>
    </div>
  </div>
  @if ((loading$ | async)) {
    <div class="link-loading">
      <i  class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
    </div>
  }
</div>
